import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { Grid, Rating, useTheme, Avatar } from "@mui/material";
import DetailHeader from "../components/detail/detailHeader";
import {
  DivCoverReturn,
  DivContent,
  DivTopic,
  TextMainTopic,
  TextData,
  ViewButton,
  TextTopic,
  DivTopicAndData,
  StatusData,
} from "../../../shared/styledComponent";
import DeleteModal from "../../../shared/deleteModal";
import GoogleApi from "../../../user/sampleshuttle/NewSample/CardDetailSample/showMap";
import { postDeleteDeliverySampleshuttle } from "../../../../../actions/deliverySampleshuttle";
import { getDeliverySampleshuttleByAdminFilter } from "../../../../../actions/deliverySampleshuttle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { getBetweenSiteByAdminFilter } from "../../../../../actions/betweenSiteCarBooking";
import BetweenSiteCarService from "../../../../../services/betweenSiteCar.service";
require("dayjs/locale/th");
dayjs.locale("th");

const DetailBetweenSite = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [booking, setBooking] = useState(props.location.state.booking);

  const getNearestTimeAndDistance = async (getting, to, idUser) => {
    const result = await BetweenSiteCarService.getNearestTimeAndDistance(
      getting,
      to,
      idUser
    );
    return result.data.result;
  };

  const [nearestTimeAndDistance, setNearestTimeAndDistance] = useState(null);

  useEffect(() => {
    if (props.location.state === undefined) {
      props.history.push("/admin/car_management");
    } else if (
      (booking.targetStatus === "Waiting" ||
        booking.targetStatus === "GettingPlace") &&
      booking.idDriver
    ) {
      const updateETA = async () => {
        try {
          const data = await getNearestTimeAndDistance(
            booking.fromPlaceIdScgSite,
            booking.toPlaceIdScgSite,
            booking.idDriver
          );
          setNearestTimeAndDistance(data);
        } catch (error) {
          console.error("Error fetching nearest time:", error);
        }
      };

      updateETA();
      const interval = setInterval(updateETA, 60000);
      return () => clearInterval(interval);
    }
  }, [props.location.state.booking]);

  const onCloseModalHandle = () => {
    setOpenModal(false);
  };

  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  const theme = useTheme();
  const [openDeleteBooking, setOpenDeleteBooking] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState("");

  const onDeleteHandler = () => {
    setOpenDeleteBooking(true);
  };
  const onCloseDialog = () => {
    setOpenDeleteBooking(false);
  };

  const onClickDeleteList = async () => {
    const id = booking.idBetweenSiteCar;
    const data = {
      id: id,
    };
    const result = await BetweenSiteCarService.deleteBetweenSiteCar(data)
      .then((res) => {
        if (res.status === 200) {
          enqueueSnackbar("Delete Success", { variant: "success" });
          setOpenDeleteBooking(false);
          if (props.endDate) {
            let date = {
              startDate: new Date(props.startDate),
              endDate: new Date(props.endDate),
            };
            dispatch(
              getBetweenSiteByAdminFilter({
                startDate: date.startDate,
                endDate: date.endDate,
              })
            );
          } else {
            let date = {
              startDate: new Date(props.startDate),
            };
            dispatch(
              getBetweenSiteByAdminFilter({ startDate: date.startDate })
            );
          }
          props.history.push("/admin/car_management/between_site_car");
        } else {
          enqueueSnackbar("Delete Failed", { variant: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onClickOpenCancelModal = () => {
    setOpenCancelModal(true);
  };
  const onCloseCancelModalHandle = () => {
    setOpenCancelModal(false);
  };

  const onClickCancel = async () => {
    const id = booking.idBetweenSiteCar;
    console.log("deleting : " + id);
    if (id !== undefined && id) {
      BetweenSiteCarService.CancelCallCar({ bookingId: id })
        .then((res) => {
          if (res.status === 200) {
            enqueueSnackbar("Cancel Success", { variant: "success" });
            props.history.push("/admin/car_management/between_site_car");
            setOpenCancelModal(false);
            if (props.endDate) {
              let date = {
                startDate: new Date(props.startDate),
                endDate: new Date(props.endDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({
                  startDate: date.startDate,
                  endDate: date.endDate,
                })
              );
            } else {
              let date = {
                startDate: new Date(props.startDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({ startDate: date.startDate })
              );
            }
          } else {
            enqueueSnackbar("Cancel Failed", { variant: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      {booking && (
        <DivCoverReturn>
          <DivContent>
            {booking.isFinish === 0 ? (
              <DetailHeader
                title="จองรถรับส่งระหว่าง SITE"
                onBack={() => props.history.goBack()}
                onEdit={() =>
                  props.history.push(
                    "/admin/car_management/between_site_car/edit_detail",
                    { booking: booking }
                  )
                }
                onCancel={onClickOpenCancelModal}
              />
            ) : (
              <DetailHeader
                title="จองรถรับส่งระหว่าง SITE"
                onBack={() => props.history.goBack()}
                onEdit={
                  booking.targetStatus !== "Cancel" &&
                  (() =>
                    props.history.push(
                      "/admin/car_management/between_site_car/edit_detail",
                      { booking: booking }
                    ))
                }
                onDelete={onDeleteHandler}
              />
            )}
            <DivTopic>
              <TextMainTopic>รายละเอียดคนขับรถ</TextMainTopic>
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid
                  xs={12}
                  md={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Avatar
                    src={`${process.env.REACT_APP_URL}image/profile/1.jpg`}
                    alt="Profile"
                    sx={{
                      width: { xs: "120px", md: "100px" },
                      height: { xs: "120px", md: "100px" },
                      margin: "1rem",
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={10}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      md={5}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <DivTopicAndData>
                        <TextTopic>ชื่อคนขับรถ</TextTopic>
                        <TextData>
                          {booking.firstnameDriver && booking.lastnameDriver
                            ? `${booking.firstnameDriver} ${booking.lastnameDriver}`
                            : `รอการจัดหาคนขับรถ`}
                        </TextData>
                      </DivTopicAndData>
                      <DivTopicAndData>
                        <TextTopic>เบอร์คนขับ</TextTopic>
                        <TextData>{booking.phoneDriver}</TextData>
                      </DivTopicAndData>
                      <DivTopicAndData>
                        <TextTopic>คะแนน</TextTopic>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "4px",
                          }}
                        >
                          <Rating
                            name="read-only"
                            value={booking.driverPoint}
                            precision={0.5}
                            size="small"
                            readOnly
                          />
                          <TextData>{booking.driverPoint}</TextData>
                        </div>
                      </DivTopicAndData>
                    </Grid>
                    <Grid
                      item
                      md={7}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <DivTopicAndData>
                        <TextTopic>ตำแหน่ง</TextTopic>
                        <TextData>
                          {booking.positionDriver
                            ? booking.positionDriver
                            : "-"}
                        </TextData>
                      </DivTopicAndData>
                      <DivTopicAndData>
                        <TextTopic>แผนก</TextTopic>
                        <TextData>
                          {booking.departmentDriver
                            ? booking.departmentDriver
                            : "-"}
                        </TextData>
                      </DivTopicAndData>
                      <DivTopicAndData>
                        {/* What is this (from old code) */}
                        <TextTopic>จำนวนรับ</TextTopic>
                        <TextData>23</TextData>
                      </DivTopicAndData>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DivTopic>

            <DivTopic>
              <TextMainTopic>รายละเอียดการจอง</TextMainTopic>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <DivTopicAndData>
                    <TextTopic>วัน - เวลา ที่จอง</TextTopic>
                    <TextData>
                      {new Date(booking.date).toLocaleString("th-TH", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
                {nearestTimeAndDistance &&
                  booking.isFinish === 0 &&
                  (booking.targetStatus === "Waiting" ||
                    booking.targetStatus === "GettingPlace") && (
                    <Grid item xs={12} md={12}>
                      <DivTopicAndData>
                        <TextTopic>ระยะเวลาที่คาดว่าจะถึง:</TextTopic>
                        <TextData>
                          {nearestTimeAndDistance.distance},{" "}
                          {nearestTimeAndDistance.duration}
                        </TextData>
                      </DivTopicAndData>
                    </Grid>
                  )}
                {booking.pickupTime && (
                  <Grid item xs={12} md={6}>
                    <DivTopicAndData>
                      <TextTopic>วัน - เวลา ที่รับผู้โดยสาร</TextTopic>
                      <TextData>
                        {new Date(booking.pickupTime).toLocaleString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                )}
                {booking.dropoffTime && (
                  <Grid item xs={12} md={6}>
                    <DivTopicAndData>
                      <TextTopic>วัน - เวลา ที่ส่งผู้โดยสาร</TextTopic>
                      <TextData>
                        {new Date(booking.dropoffTime).toLocaleString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextMainTopic>จุดรับส่ง</TextMainTopic>
                </Grid>
                <Grid item xs={12}>
                  <DivTopicAndData>
                    <LocationOnIcon
                      sx={{
                        height: "20px",
                        color: "green",
                        verticalAlign: "middle",
                        marginRight: "4px",
                      }}
                    />
                    <TextTopic>จุดรับต้นทาง</TextTopic>
                    <TextData sx={{ textWrap: "wrap" }}>
                      {booking.fromPlace}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
                <Grid item xs={12}>
                  <DivTopicAndData>
                    <LocationOnIcon
                      sx={{
                        height: "20px",
                        color: "red",
                        verticalAlign: "middle",
                        marginRight: "4px",
                      }}
                    />
                    <TextTopic>จุดส่งปลายทาง</TextTopic>
                    <TextData sx={{ textWrap: "wrap" }}>
                      {booking.toPlace}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
              </Grid>
            </DivTopic>

            <DivTopic>
              <TextMainTopic>รายละเอียดผู้จอง</TextMainTopic>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <DivTopicAndData>
                    <TextTopic>ชื่อผู้จอง</TextTopic>
                    <TextData>
                      {`${booking.firstnameEmployee} ${booking.lastnameEmployee}`}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
                <Grid item xs={12} md={6}>
                  <DivTopicAndData>
                    <TextTopic>เบอร์ผู้จอง</TextTopic>
                    <TextData>
                      {booking.phoneRequester
                        ? booking.phoneRequester
                        : booking.phoneEmployee
                        ? booking.phoneEmployee
                        : null}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
              </Grid>
            </DivTopic>

            <DivTopic>
              <TextMainTopic>สถานะรถรับส่งระหว่าง SITE</TextMainTopic>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>สถานะ</TextTopic>
                    {booking.isFinish === 1 ? (
                      booking.targetStatus === "Cancel" ? (
                        <StatusData style={{ color: "#8f8f8f" }}>
                          ยกเลิกรายการ
                        </StatusData>
                      ) : (
                        <StatusData style={{ color: "#24944f" }}>
                          รายการเสร็จสิ้น
                        </StatusData>
                      )
                    ) : booking.targetStatus === "Waiting" ? (
                      <StatusData style={{ color: "#d42121" }}>
                        รอการจัดหาคนขับรถ
                      </StatusData>
                    ) : (
                      <StatusData style={{ color: "#FF9800" }}>
                        กำลังดำเนินการ
                      </StatusData>
                    )}
                  </DivTopicAndData>
                </Grid>
                {booking.isFinish === 0 &&
                  booking.targetStatus !== "Waiting" && (
                    <Grid item xs={12} lg={6}>
                      <DivTopicAndData>
                        <TextTopic>สถานะคนขับรถ</TextTopic>
                        <StatusData style={{ color: "#FF9800" }}>
                          {booking.targetStatus === "GettingPlace"
                            ? "กำลังไปรับที่จุดรับต้นทาง"
                            : "กำลังไปส่งที่จุดส่งปลายทาง"}
                        </StatusData>
                      </DivTopicAndData>
                    </Grid>
                  )}
              </Grid>
            </DivTopic>
            <Grid item xs={12}>
              <ViewButton onClick={onClickOpenModal}>แสดงแผนที่</ViewButton>
            </Grid>
          </DivContent>
          <GoogleApi
            open={openModal}
            onCloseHandle={onCloseModalHandle}
            inforInCar={booking}
            typeOfBooking={"BetweenSiteCar"}
          />
          <DeleteModal
            open={openDeleteBooking}
            onCloseDeleteModalHandle={onCloseDialog}
            onClickDelete={onClickDeleteList}
            label={
              <>
                ลบรายการจอง
                <br />
                ข้อมูลการจองนี้จะหายไปและไม่สามารถกู้คืนได้
              </>
            }
          />
          <DeleteModal
            open={openCancelModal}
            onClickDelete={onClickCancel}
            onCloseDeleteModalHandle={onCloseCancelModalHandle}
            label={"ยกเลิกรายการจอง"}
          />
        </DivCoverReturn>
      )}
    </>
  );
};

export default DetailBetweenSite;
